import axios from '@axios'

const PREFIX = '/tipos-atividade'

export default {

  getTiposAtividade(page, pageSize, filtros) {
    return axios.post(`${PREFIX}?page=${page}&pageSize=${pageSize}`, filtros)
  },

  getTipoAtividade(id) {
    return axios.get(`${PREFIX}/${id}`)
  },

  createTipoAtividade(form) {
    return axios.post(`${PREFIX}/add`, form)
  },

  updateTipoAtividade(id, form) {
    return axios.put(`${PREFIX}/${id}`, form)
  },

  deleteTipoAtividade(id) {
    return axios.delete(`${PREFIX}/${id}`)
  },

  getAtividadesResumidas(filtros) {
    return axios.post(`${PREFIX}/resumida`, filtros)
  },

  existeAtividadeVinculoChecklist(id) {
    return axios.get(`${PREFIX}/existe-vinculo/${id}`)
  },

  deleteAll(idList) {
    return axios.delete(`${PREFIX}/lote`, { data: idList })
  },

}
